import './lightbox.js';

window.onload = () => {
    const burger = document.getElementById("burger");
    if (screen.width < 768) {
        burger.classList = "plate plate7";
    }
  };


//Menu Mobile
document.querySelector("div.plate").addEventListener('click', () => {
    const menu = document.getElementById("menu");
    const main = document.getElementById("main");
    const body = document.querySelector("body")

    if (menu.className === "nav-menu") {
        menu.className = "nav-menu-open";
        main.className = "main main-menu-open";
        body.className = "body-menu-open";
    } else {
        menu.className = "nav-menu";
        main.className = "main";
        body.className = "";
    }
});

//Logo-bg
const bg = document.getElementById("logo-bg");

function changeImg(){
    screen.width >= 1300 ? bg.src = "/images/languette.svg" : bg.src = "/images/languette-min.svg";
}

//Project Bento
const item1 = document.querySelector("div.b-item1");
const item2 = document.querySelector("div.b-item2");
const item3 = document.querySelector("div.b-item3");
const item4 = document.querySelector("div.b-item4");

if (item1) {
    item1.addEventListener("mouseover", () => {
        item1.classList.add("b-hover");
        item2.classList.add("b-unhover");
        item2.classList.remove("b-hover");
    });
    item2.addEventListener("mouseover", () => {
        item2.classList.add("b-hover");
        item2.classList.remove("b-unhover");
        item1.classList.remove("b-hover");
    });
    item3.addEventListener("mouseover", () => {
        item3.classList.add("b-hover");
        item3.classList.remove("b-unhover");
        item4.classList.remove("b-hover");
    });
    item4.addEventListener("mouseover", () => {
        item4.classList.add("b-hover");
        item3.classList.add("b-unhover");
        item3.classList.remove("b-hover");
    });
}

//Responsive bubbles
function bubblesHeight() {
    
    const circles = document.querySelector("ul.circles");
    
    if (circles) {
        const HProfil = document.getElementById("profil").offsetHeight;
        const HServices = document.getElementById("services").offsetHeight;

        var height = HProfil + HServices + 300;
        circles.setAttribute("style", "height:" + height + "px;");    
    }
}

//Top-bar on scroll
document.addEventListener("scroll", () => {
    const bgTopbar = document.querySelector("div.bg-top-bar");
    if (window.scrollY>0) {
        bgTopbar.classList.add("scrolled");
    } else {
        bgTopbar.classList.remove("scrolled");
    }
})


window.onload = changeImg(), bubblesHeight();
window.onresize = changeImg(), bubblesHeight();